import ModelRepository from './modelRepository'
import ObjectRepository from './objectRepository'


export default {
    ModelRepository,
    ObjectRepository,
}
